<script>
    import Logout from '/public/components/users/Logout.svelte';   
</script>

<main>
    <div class="row justify-content-center mt-3 mb-3">
        <div class="col-sm-10 col-md-6 col-lg-4">
            <Logout/>
        </div>
    </div>
</main>
